import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { updateUserEmail } from 'services/api/auth-api.service';

export default function useUpdateUserEmail(
  options?: UseMutationOptions<any, Error, string, unknown>,
) {
  return useMutation({
    mutationFn: updateUserEmail,
    ...options,
  });
}
